// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1FzGj","title":"Header_title__2MifE","side":"Header_side__1H73r"};